import { Injectable, DOCUMENT, inject } from '@angular/core';
import { PorIcon, PorIconModel } from '@por/icon-lib/icons';
import { POR_SVG_ICONS } from './config';
import { ICONS_USED_BY_LIB } from './icons-internal';

@Injectable({
    providedIn: 'root'
})
export class PorIconService {
    private readonly document = inject<Document>(DOCUMENT, { optional: true });

    private readonly _svgDefinitions = new Map<string, PorIconModel>();

    constructor() {
        const porIcons = inject(POR_SVG_ICONS, { optional: true }) ?? [];

        this.addIconsToRegistry([...ICONS_USED_BY_LIB, ...porIcons]);
    }

    getIconSvg(icon: PorIcon): SVGElement | null {
        const model = this._svgDefinitions.get(icon);
        if (model) {
            return this.createSVGElement(model.data);
        } else {
            throw new Error(`The icon (${icon}) you provided is not registered in the module.`);
        }
    }

    configureSVGElement(svg: SVGElement, width: number, height: number, color: string): SVGElement {
        svg.setAttribute('width', String(width));
        svg.setAttribute('height', String(height));
        svg.setAttribute('fill', String(color));
        return svg;
    }

    private createSVGElement(icon: string): SVGElement | null {
        if (!this.document) {
            throw new Error('Document is not available');
        }
        const div = this.document.createElement('div');
        div.innerHTML = icon;
        const svg = div.querySelector('svg');
        if (!svg) {
            throw new Error('Could Not Find SVG');
        }
        return svg;
    }

    private addIconsToRegistry(icons: PorIconModel[]) {
        icons.forEach(icon => {
            this._svgDefinitions.set(icon.name, icon);
        });
    }
}
